import React from "react";
import logoWCE from "images/logo-wce.png";
import logoUIWIB from "images/logo-uiwib.png";
import iconTiktok from "images/icon/tiktok.png";
import { lang } from "constant/lang";
import {
  AiOutlineInstagram,
  AiOutlineLinkedin,
  AiOutlineMail,
} from "react-icons/ai";

const Footer = () => {
  return (
    <footer className="relative bottom-0 w-full md2:h-[184px] bg-wce-neutral-2 z-10">
      <div className="flex flex-col md2:flex-row p-6 md2:p-10 items-center justify-between h-full gap-6">
        <div className="flex gap-10 min-w-[275px]">
          <img src={logoWCE} alt="logo" className="w-[152px] h-[80px]" />
          <img src={logoUIWIB} alt="logo" className="w-[83px] h-[80px]" />
        </div>
        <div className="flex flex-col items-center">
          <div className="text-wce-neutral-7 mb-2 sm:mb-4 text-sm sm:text-base">
            {lang.footer.center.p1}
          </div>
          <div className="text-wce-neutral-7 text-center text-xs sm:text-base">
            {lang.footer.center.p2}
            <br />
            {lang.footer.center.p3}
          </div>
        </div>
        <div className="flex flex-col gap-2 text-sm sm:text-base items-center sm:text-center">
          <div className="flex gap-2 items-center">
            <AiOutlineInstagram size={18} className="text-wce-neutral-10" />
            <div className="text-wce-neutral-7">
              {lang.footer.right.instagram}
            </div>
          </div>
          <div className="flex gap-2 items-center">
            <AiOutlineLinkedin size={18} className="text-wce-neutral-10" />
            <div className="text-wce-neutral-7">
              {lang.footer.right.linkedin}
            </div>
          </div>
          <div className="flex gap-2 items-center">
            <img src={iconTiktok} alt="tiktok" className="w-5" />
            <div className="text-wce-neutral-7">{lang.footer.right.tiktok}</div>
          </div>
          <div className="flex gap-2 items-center">
            <AiOutlineMail size={18} className="text-wce-neutral-10" />
            <div className="text-wce-neutral-7">{lang.footer.right.email}</div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
